module.exports = __webpack_public_path__ + "img/28.8609a453.svg";